var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.DynamicPageHtml)?_c('div',[_c('div',{staticClass:"scoped-dynamic-content",domProps:{"innerHTML":_vm._s(_vm.DynamicPageHtml)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }